<template>
	<div>
        <!-- <header-page
			name="apps"
			:title="$route.meta.title"
		/> -->
        <v-flex class="scroll-container">
            <v-flex xs7 ml-5 mt-4>
                <v-layout column>
                    <span class="grey--text text--darken-2 caption font-weight-bold uppercase mb-1">Nro. de Sucursales</span>
                    <v-layout row align-center>
                        <v-btn fab small color="white" @click="removeSubsidiary" class="btn-extra-small elevation-1">
                            <v-icon color="grey darken-2" small>remove</v-icon>
                        </v-btn>
                        <span class="mx-3 subheading font-weight-medium grey--text text--darken-3">
                            {{ subsidiaries.length }}
                        </span>
                        <v-btn fab small color="white" @click="addSubsidiary" class="btn-extra-small elevation-1">
                            <v-icon color="primary" small>add</v-icon>
                        </v-btn>
                    </v-layout>
                </v-layout>
            </v-flex>
            <transition name="fade" mode="out-in">
                <v-layout
                    row wrap mb-5
                    v-if="subsidiaries.length > 0"
                    :class="subsidiaries.length > 0 ? 'pb-price' : ''"
                >
                    <v-flex
                        v-for="(subs, indexSubs) in subsidiaries"
                        xs10 :key="indexSubs"
                    >
                        <v-layout row wrap>
                            <v-flex xs12 mt-4>
                                <v-layout row wrap align-center>
                                    <v-flex :class="!isEdit ? 'xs3' : 'xs5'" text-xs-center>
                                        <v-layout xs2 text-xs-center pl-5>
                                            <v-icon @click="editSubsidiary">edit</v-icon>
                                            <span class="subsidiary--name" v-if="!isEdit">{{ subs.subsidiaryName }}</span>
                                            <v-flex xs12 ml-4 mr-4 v-else>
                                                <v-text-field
                                                    background-color="white"
                                                    box
                                                    hide-details
                                                    label="Nombre de Sucursal"
                                                    required
                                                    v-model="subs.subsidiaryName"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs4 pl-3>
                                        <v-layout column>
                                            <span class="grey--text text--darken-2 caption font-weight-bold uppercase mb-1">Nro. de Tiendas</span>
                                            <v-layout row align-center>
                                                <v-btn fab small color="white" @click="removeWarehouse(indexSubs)" class="btn-extra-small elevation-1">
                                                    <v-icon color="grey darken-2" small>remove</v-icon>
                                                </v-btn>
                                                <span class="mx-3 subheading font-weight-medium grey--text text--darken-3">
                                                    {{ subs.warehouse.length }}
                                                </span>
                                                <v-btn fab small color="white" @click="addWarehouse(indexSubs)" class="btn-extra-small elevation-1">
                                                    <v-icon color="primary" small>add</v-icon>
                                                </v-btn>
                                            </v-layout>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout
                                    row wrap
                                    v-if="subsidiaries[indexSubs].warehouse.length > 0"
                                    :class="subsidiaries[indexSubs].warehouse.length > 0 ? 'pb-price' : ''"
                                >
                                    <v-flex
                                        v-for="(warehouse, indexWarehouse) in subsidiaries[indexSubs].warehouse"
                                        xs12 :key="indexWarehouse"
                                    >
                                        <v-layout row wrap>
                                            <v-flex xs12 pb-3 ml-5>
                                                <v-layout row wrap align-center>
                                                    <v-flex :class="!isEditWarehouse ? 'xs3' : 'xs5'" text-xs-center>
                                                        <v-layout xs2 text-xs-center pl-5>
                                                            <v-icon @click="editWarehouse">edit</v-icon>
                                                            <span class="subsidiary--name" text-xs-start v-if="!isEditWarehouse">{{ warehouse.warehouseName }}</span>
                                                            <v-flex xs12 ml-4 mr-4 v-else>
                                                                <v-text-field
                                                                    background-color="white"
                                                                    box
                                                                    hide-details
                                                                    label="Nombre de la tienda"
                                                                    required
                                                                    v-model="warehouse.warehouseName"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs3 pl-1>
                                                        <v-text-field
                                                            background-color="white"
                                                            box
                                                            class="body-1"
                                                            hide-details
                                                            label="Dominio"
                                                            required
                                                            v-model="warehouse.suffixDomain"
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs1 class="pl-2">
                                                        <v-btn
                                                            @click="asignEmployee(indexSubs, indexWarehouse)"
                                                            color="primary"
                                                            class="elevation-2"
                                                            fab
                                                            small
                                                        >
                                                            <v-icon>person_add</v-icon>
                                                        </v-btn>
                                                    </v-flex>
                                                    <v-flex xs1 class="d-flex align-center justify-center" v-if="validateUser(warehouse.user)">
                                                        <v-tooltip top>
							                                <template slot="activator">
                                                                <div style="display: flex; align-items: center;">
                                                                    <v-icon color="success">check</v-icon>
                                                                    <span class="ml-1">{{ validateUser(warehouse.user) }}</span>
                                                                </div>
                                                            </template>
                                                            <span>Cantidad de empleados: {{ validateUser(warehouse.user) }}</span>
                                                        </v-tooltip>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </transition>
        </v-flex>
        <action-sidebar
			:title="action.title"
            :width="action.width"
			:value="action.open"
			@close-modal="closeModal"
		>
			<asign-employee 
                v-if="action.code === 'AE'"
                :code-project="codeProject"
                :users-exist="users"
                :id-template="Number(idTemplate)"
                @save-data="saveUsers"
                @close-modal="closeModal"
            />
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import asignEmployee from '@/components/configuration-general/asign-employee';


function data() {
	return {
		subsidiaries: [],
		loading: false,
        countSubsidiary: null,
        isEdit: false,
        countWarehouse: 0,
		model: {
			codeProject: '',
			description: '',
			name: '',
		},
        action: {
            title: '',
            open: false,
            code: '',
            width: 0,
        },
        indexSubs: null,
        indexWarehouse: null,
        users: [],
        isEditWarehouse: false,
	};
}

function closeModal() {
	this.action = {
        title: '',
        open: false,
        code: '',
        width: 0,
    };
}

function created() {
    ({ codeProject: this.codeProject, idTemplate: this.idTemplate } = this.$route.params);
    if (this.data) {
        this.loadData();
    }
}

async function loadData() {
    if (this.data.settings) {
        this.subsidiaries = this.data.settings && this.data.settings.company ?
            this.data.settings.company.subsidiary : [];
        this.countSubsidiary = this.subsidiaries.length;
    }
}

export default {
	name: 'configuration-subsidiary',
	data,
    components: {
        actionSidebar,
        asignEmployee,
    },
    created,
	methods: {
        loadData,
        addSubsidiary() {
            const currentLength = this.subsidiaries.length;
            this.subsidiaries.push({
                subsidiaryName: `Sucursal ${currentLength + 1}`,
                uid: `SUB0${currentLength + 1}`,
                storeCount: 0,
                warehouse: [],
            });
        },
        removeSubsidiary() {
            if (this.subsidiaries.length > 0) {
                this.subsidiaries.pop();
            }
        },
        addWarehouse(index) {
            if (index >= 0 && index < this.subsidiaries.length) {
                const sub = this.subsidiaries[index];
                const currentLength = sub.warehouse.length;

                sub.warehouse.push({
                    uid: `WAR0${currentLength + 1}`,
                    warehouseName: `Tienda ${currentLength + 1}`,
                    user: [],
                    suffixDomain: '',
                });
                sub.storeCount = sub.warehouse.length;
            }
        },
        removeWarehouse(index) {
            if (index >= 0 && index < this.subsidiaries.length) {
                const sub = this.subsidiaries[index];
                if (sub.warehouse.length > 0) {
                    sub.warehouse.pop();
                    sub.storeCount = sub.warehouse.length;
                }
            }
        },
        asignEmployee(indexSubs, indexWarehouse) {
            this.action.open = true;
            this.action.code = 'AE';
            this.action.title = 'Asignar Empleados';
            this.action.width = 800;
            this.users = [];
            if (this.subsidiaries[indexSubs].warehouse[indexWarehouse].user.length > 0) {
                this.users = this.subsidiaries[indexSubs].warehouse[indexWarehouse].user;
            }
            this.indexSubs = indexSubs;
            this.indexWarehouse = indexWarehouse;
        },
        saveUsers(user) {
            this.subsidiaries[this.indexSubs].warehouse[this.indexWarehouse].user = user;
            this.users = [];
            this.closeModal();
        },
        editSubsidiary() {
            this.isEdit = !this.isEdit;
        },
        editWarehouse() {
            this.isEditWarehouse = !this.isEditWarehouse;
        },
		closeModal,
        validateUser(user) {
            const quantity = user.reduce((acc, us) => acc + us.quantity, 0);
            return quantity;
        },
	},
    props: {
        data: {
            type: Object,
        },
    },
    watch: {
        subsidiaries: {
            handler(newVal) {
                this.$emit('update:subsidiaries', newVal, 'subsidiaries');
            },
            deep: true
        }
    },
};
</script>
<style scoped>

.pb-price {	
    border-bottom: 1px solid color(border-green-light);
	margin: 7px 0px;
}

.modal-filter {
    position: absolute;
    bottom: 0;
    width: 100%;
}

.subsidiary--name {
    margin-left: 20px;
}

.scroll-container {
    max-height: 650px;
    overflow-y: auto;
}

.btn-extra-small {
    height: 30px !important;
    width: 30px !important;
}

</style>


// WEBPACK FOOTER //
// src/components/configuration-general/configuration-subsidiary.vue